import React, { useEffect } from "react";
import { FocusContext, useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { safeSetFocus } from "../../epg/utils/shared/focus";
import "./ConfirmDialog.scss";

const Button = ({ text, onPress, focusKey }) => {
    const { ref, focused } = useFocusable({
        focusKey: focusKey,
        onEnterPress: onPress,
    });

    return (
        <div ref={ref}>
            <button className={`fullWidthBtn ${focused ? "focused" : ""}`} onClick={onPress} tabIndex={-1} aria-label={text}>
                {text}
            </button>
        </div>
    );
};

const ConfirmDialog = ({ title, description, confirmTitle, cancelTitle, onConfirmPressed, onCancelPressed }) => {
    const { ref, focusKey } = useFocusable({
        isFocusBoundary: true,
    });

    // Focus management
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            safeSetFocus("DIALOG_CANCEL");
        }, 50);
    }, []);

    return (
        <FocusContext.Provider value={focusKey}>
            <div className="backdrop" role="dialog" aria-modal="true">
                <div ref={ref} className="modalBox">
                    <h2 className="title">{title}</h2>
                    <p className="message">{description}</p>
                    <Button text={cancelTitle} onPress={onCancelPressed} focusKey="DIALOG_CANCEL" />
                    <Button text={confirmTitle} onPress={onConfirmPressed} focusKey="DIALOG_CONFIRM" />
                </div>
            </div>
        </FocusContext.Provider>
    );
};

export default ConfirmDialog;
